import { ImageInfo, ImageInfoType } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Image';
import { EntityImageType } from '@decisions/server/DecisionsFramework/ServiceLayer/EntityImageType';
import { ElementType } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ConfigurationStorage/ElementType';

export function getImageForEntity(entityId: string, entityType: string) {
  return `${virtualPath}/action/GetImageForEntity?entityId=${entityId}&typeName=${entityType}&imageType=${EntityImageType.Icon}`;
}

export function loadDesignerThumbnailImage(entityId: string, ticks: number) {
  return `${virtualPath}/HtmlPage/Page/LoadDesignerThumbnailImage?entityId=${entityId}&ticks=${ticks}`;
}

export function getElementTypeIcon(elementType: ElementType, width: number, height: number, color: string) {
  return `${virtualPath}/action/GetElementTypeIcon?elementType=${elementType}&width=${width}&height=${height}&color=${encodeURIComponent(
    color
  )}`;
}

export function getImageInfoUrl(
  info: ImageInfo,
  width: number = 48,
  height: number = 48,
  color: string | undefined = undefined
) {
  if (!info || undefined === info.ImageType) {
    return null;
  }

  if (info.ImageType === ImageInfoType.Url) {
    return info.ImageUrl;
  } else if (info.ImageType === ImageInfoType.StoredImage) {
    return `${virtualPath}/Handlers/SvgImage.ashx?svgFile=${encodeURIComponent(
      info.ImageId
    )}&width=${width}&height=${height}${color && color.length ? `&color=${encodeURIComponent(color)}` : ''}`;
  } else if (info.ImageType === ImageInfoType.Document) {
    return `${virtualPath}/Handlers/SvgImage.ashx?documentId=${encodeURIComponent(
      info.DocumentId
    )}&width=${width}&height=${height}`;
  } else if (info.ImageType === ImageInfoType.RawData && info.RawData && info.RawData.length) {
    return getImageUrlFromBytes(info.RawData);
  } else if (info.ImageType === ImageInfoType.RawData && info.ImageFileReferenceId != null) {
    const encodedFileName = encodeURIComponent(info.ImageName);
    return `${Decisions.DataTypes.baseURL}FileReferenceService/JS/DownloadFile?id=${info.ImageFileReferenceId}&fileName=${encodedFileName}`;
  }

  return null;
}

export function getImageUrlFromBytes(imageData: number[] | string) {
  if (imageData) {
    let encodedString;
    if (typeof imageData == 'string') {
      encodedString = imageData;
    } else {
      encodedString = encodeByteArrayToBase64String(imageData);
    }

    let imageType: string = 'image/bmp';
    switch (encodedString[0]) {
      case 'i':
        imageType = 'image/png';
        break;
      case 'R':
        imageType = 'image/gif';
        break;
      case '/':
        imageType = 'image/jpg';
        break;
    }

    return `data:${imageType};base64,${encodedString}`;
  }
}

export function encodeByteArrayToBase64String(data: number[]): string {
  return btoa(
    new Uint8Array(data).reduce(function(data, byte) {
      return data + String.fromCharCode(byte);
    }, '')
  );
}

export function getStoredSvgImageInfoUrl(image: ImageInfo) {
  if (!image) return undefined;
  if (!!image.ImageUrl) return image.ImageUrl;

  return `${virtualPath}/Handlers/SvgImage.ashx?svgFile=${encodeURIComponent(image.ImageId)}&format=svg`;
}

export const ImageUtils = {
  getImageUrlFromBytes,
  getImageInfoUrl,
  getStoredSvgImageInfoUrl,
};
